exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#mobileMenu[data-v-812b4e92] {\n  height: calc(100vh - 4rem);\n  background: rgba(255, 255, 255, 0.97);\n}\n", ""]);

// exports
